import { findDietTagImg } from '../helpers/singleOfferHelpers';

const BarWithSelectOnMobile = ({ showSelect, selectedDiet, openModal }) => {
  return (
    <div
      className="menu-widget-catering-menu__carousel-diets-wrapper menu-widget-catering-menu__carousel-diets-wrapper--no-border spacer-bottom-16"
      onClick={() => {
        if (showSelect) {
          openModal();
        }
      }}
      onKeyPress={openModal}
      role="button"
      tabIndex="0"
    >
      <div
        className={'menu-widget-select__selectedItemWithImg-img-mobile'}
        style={{
          backgroundImage: `url(${selectedDiet?.dietImageUrl ? selectedDiet?.dietImageUrl : findDietTagImg(selectedDiet?.dietTag)})`,
        }}
      />
      <div className="menu-widget-catering-menu-bar-with-select-on-mobile">
        <div className="menu-widget-catering-menu-bar-with-select-on-mobile-diet-name">
          {selectedDiet?.dietName}
        </div>
        {showSelect && (
          <div
            className={
              'menu-widget-catering-menu-bar-with-select-on-mobile-icon--down'
            }
          >
            <svg
              width="22.5"
              height="15"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.9999 1.1697C10.8126 0.983448 10.5591 0.878906 10.2949 0.878906C10.0308 0.878906 9.77731 0.983448 9.58995 1.1697L5.99995 4.7097L2.45995 1.1697C2.27259 0.983448 2.01913 0.878906 1.75495 0.878906C1.49076 0.878906 1.23731 0.983448 1.04995 1.1697C0.95622 1.26266 0.881826 1.37326 0.831057 1.49512C0.780288 1.61698 0.75415 1.74769 0.75415 1.8797C0.75415 2.01171 0.780288 2.14242 0.831057 2.26428C0.881826 2.38613 0.95622 2.49674 1.04995 2.5897L5.28995 6.8297C5.38291 6.92343 5.49351 6.99782 5.61537 7.04859C5.73723 7.09936 5.86794 7.1255 5.99995 7.1255C6.13196 7.1255 6.26267 7.09936 6.38453 7.04859C6.50638 6.99782 6.61699 6.92343 6.70995 6.8297L10.9999 2.5897C11.0937 2.49674 11.1681 2.38613 11.2188 2.26428C11.2696 2.14242 11.2957 2.01171 11.2957 1.8797C11.2957 1.74769 11.2696 1.61698 11.2188 1.49512C11.1681 1.37326 11.0937 1.26266 10.9999 1.1697Z"
                fill="#62748C"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default BarWithSelectOnMobile;
